import { get } from "lodash";

import { useFormatCurrency } from "@krea/customer-features/hooks";
import { settings } from "@krea/customer-features/settings";
import Button from "@krea/customer-features/shared-components/button";
import Fieldset from "@krea/customer-features/shared-components/fields/fieldset";
import TextInput from "@krea/customer-features/shared-components/fields/input";
import { FormatNumber } from "@krea/customer-features/utils";

const EditRefinancingAmount = ({
  onSaveClick,
  inputChange,
  onCloseClick,
  t,
  refinancingAmount,
  isOpen,
  errors,
}) => {
  const currency = settings.currency;
  const [, currencyValue] = useFormatCurrency({ currency });

  return (
    <div className="pb-4">
      {!isOpen ? null : (
        <div className="d-flex justify-content-end">
          <Button variant="text" size="sm" onClick={onCloseClick}>
            {t("iaq.refinancingAmounts.close")}
          </Button>
        </div>
      )}

      <Fieldset>
        <TextInput
          autoFocus
          type="text"
          id="refinancing-amount-edit-lender-name"
          value={refinancingAmount?.lender_name || ""}
          onChange={({ target }) => inputChange("lender_name", target.value)}
          placeholder={t("iaq.refinancingAmounts.lenderPlaceholder")}
          label={t("iaq.refinancingAmounts.lenderLabel")}
          error={get(errors, "lender_name[0].message", null)}
        />

        <TextInput
          type="text"
          id="refinancing-amount-edit-outstanding-amount"
          value={FormatNumber(refinancingAmount?.outstanding_amount)}
          onChange={({ target }) =>
            inputChange("outstanding_amount", target.value)
          }
          placeholder={t(
            "iaq.refinancingAmounts.outstandingAmountPlaceholder",
            {
              currency: currencyValue,
            },
          )}
          label={t("iaq.refinancingAmounts.outstandingAmountLabel")}
          error={get(errors, "outstanding_amount[0].message", null)}
          textAppend={currencyValue}
        />

        <TextInput
          type="text"
          id="refinancing-amount-edit-monthly-cost"
          value={FormatNumber(refinancingAmount?.monthly_cost)}
          onChange={({ target }) => inputChange("monthly_cost", target.value)}
          placeholder={t("iaq.refinancingAmounts.monthlyCostPlaceholder", {
            currency: currencyValue,
          })}
          label={t("iaq.refinancingAmounts.monthlyCostLabel")}
          error={get(errors, "monthly_cost[0].message", null)}
          textAppend={currencyValue}
        />

        <div className="d-flex justify-content-end">
          <Button
            variant="outlined"
            size="sm"
            className="px-5"
            onClick={onSaveClick}
          >
            {t("iaq.refinancingAmounts.save")}
          </Button>
        </div>
      </Fieldset>
    </div>
  );
};

export default EditRefinancingAmount;
